import React from "react";

export type MessageType = {
    type: "success" | "error" | "info";
    text: string;
} | null;

interface MessageBoxProps {
    message: MessageType;
}

export default function MessageBox({message}: MessageBoxProps) {
    return (
        <div>
            {message && (
                <div className={`message-box ${message.type}`}>
                    {message.text}
                </div>
            )}
        </div>
    );
}